<script>
import Layout from "../../layouts/main";
import ExportButton from "@/components/export-button";
import Headers from "./table_headers";
import appConfig from "@/app.config";
import axios from "@/axios"
import { getDateWithFormat } from "@/utils";
import DPConfig from "../../../components/dataPickerConf";
import { b64toBlob, formatCurrency } from "@/utils";
import Filter from "../../../components/filters/Filter";


export default {
  page: {
    title: "CobrosAdicionales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    "export-button": ExportButton,
    "filters": Filter
  },
  data() {
    return {
      lang: {
        formatLocale: DPConfig.formatLocale
      },
      tableData: "",
      fields: Headers.cobros,
      valuePagination: {
        default: 1,
      },
      title: "Cobros Adicionales",
      period: [new Date("2000-01-01"), new Date()],
      rutEmpresa: "",
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filtros: ['rut', 'date'],
      filtersValue: {
        rutEmpresa: this.$store.state.rutEmpresa.cuentaSeleccionada.value,
        period: [new Date("2000-01-01"), new Date()],
      },
      filterOn: [],
      sortBy: "item",
      sortDesc: true,
      totRegistros: 16,
      buttonClicked: undefined,
      pdf: ""
    }
  },
  beforeMount() {
    this.getCobros();
  },
  methods: {
    getDate(date) {
      return getDateWithFormat(date);
    },
    getCurrency(inport) {
      return formatCurrency(inport);
    },
    detailView(id, confRoute) {
      this.$store.dispatch("hideValue/updateId", id);
      this.$store.dispatch("hideValue/updateFilter", this.filtersValue);
      this.$router.push(confRoute);
    },
    getCobros() {
      this.isBusy = true;
      if (this.filtersValue.rutEmpresa) {
        axios
            .get(`/GastosReembolsablesRac?IdRutFacturacion=${this.filtersValue.rutEmpresa}&FechaDesde=${getDateWithFormat(this.filtersValue.period[0], "YYYY-MM-DD")}&FechaHasta=${getDateWithFormat(this.filtersValue.period[1], "YYYY-MM-DD")}`)
            .then((cobros) => {
              this.isBusy = false;
              this.tableData = cobros.data.datos;
            })
            .catch((error) => {
              if (error.response) {
                this.$bvToast.toast(this.$t('NoData.error.message').toString(), {
                  title: this.$t('NoData.error.title').toString(),
                  variant: 'danger',
                  solid: true
                });
              }
              this.isBusy = false;
            });
      }
    },
    download(row) {
      let fileName;
      let fileType = "application/pdf";
      let downloadRequest;
      let requestBody = {
        fElecParEmpCod: "1",
        fElecDocTipo: row.item.idTipoDcto,
        fElecDocNro: row.item.idDocto.toString(),
      };
      downloadRequest = axios.post("/ObtenerDocumento", requestBody);
      fileName = `boleta_${row.item.idDocto}.pdf`;
      this.buttonClicked = row.index;
      downloadRequest
          .then((documento) => {
            if (documento.data.pdf || documento.data.bDatos) {
              const pdf = documento.data.pdf
                  ? documento.data.pdf
                  : documento.data.bDatos;
              const blob = b64toBlob(pdf, fileType);
              let fileURL = window.URL.createObjectURL(blob);
              let fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute("download", fileName);
              document.body.appendChild(fileLink);

              fileLink.click();
              this.buttonClicked = undefined;
            } else {
              this.$bvToast.toast(
                  this.$t("lease.pdf.error.nonFound").toString(),
                  {
                    title: this.$t("lease.pdf.error.download").toString(),
                    variant: "danger",
                    solid: true,
                  }
              );
              this.buttonClicked = undefined;
            }
          })
          .catch(() => {
            this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
              title: this.$t("lease.pdf.error.download").toString(),
              variant: "danger",
              solid: true,
            });
            this.buttonClicked = undefined;
          });
    }
  },
  goDocuments(detalle) {
    this.$router.push({path: "/additionals-charges/documents", query: {id: detalle.item}});
  },
    watch:{
      currentPage(){
        this.getSolicitud();
      }
  }
 
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center">
              <h4 class="card-tittle">Cobros Adicionales</h4>
              <export-button :data="tableData" fileName="AdditionalsCharges" />
            </b-row>
            <filters
              :filtros="filtros"
              :value="filtersValue"
              @change="getCobros"
            />
            <!-- Inicio Tabla -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :busy="isBusy"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                show-empty
              >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <template #cell(idContrato)="row">
                  <a
                      @click="
                      detailView(row.value, {
                        name: 'detalleContrato',
                      })
                    "
                      class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(descarga)="row" :id="`cargos-${row.item.idDocto}`">
                  <b-button variant="danger" @click="download(row)" :disabled="!row.item.idDocto">
                    <i
                        v-if="buttonClicked !== row.index"
                        class="bx bx-download font-size-16 align-middle"
                    />
                    <b-spinner v-else small class="align-middle"></b-spinner>
                  </b-button>
                  <b-tooltip :target="`cargos-${row.item.idDocto}`" triggers="hover" placement="rigth" v-if="!row.item.idDocto">
                    No existen documentos disponibles
                  </b-tooltip>
                </template>
                <template>
                  <h5 style="text-align: center">
                    {{ $t("request.table.empty") }}
                  </h5>
                </template>
                <template #cell(idReserva)="row">
                  <a
                      @click="
                      detailView(row.value, {
                        name: 'detalleReserva',
                      })
                    "
                      class="links"
                  >
                    {{ row.value }}
                  </a>
                </template>
                <template #cell(valorRecupRepto)="row">
                  {{ "$ " + getCurrency(row.value) }}
                </template>
              </b-table>
              <!-- Fin Tabla -->
              <!-- Inicio Paginación -->
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination
                    @page-click="changePage"-->
                    <b-pagination
                      class="portal"
                      v-model="currentPage"
                      :per-page="perPage"
                      :total-rows="totRegistros"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
              <!-- Fin Paginación -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
</style>
